export default "__VITE_ASSET__ef047fb5__"